import { globalRef } from '@amazon/vinyl-util'
import { MetrixUploader } from '@amzn/amp-playback'
import { pageLifecycle } from '@amzn/amp-playback/web'
import { webPlaybackAuth } from '@/auth/webPlaybackAuth'
import { webPlaybackDeviceProfile } from '@/device/webPlaybackDeviceProfile'
import { webPlaybackEndpoints } from '@/service/webPlaybackEndpoints'

export const metrixUploaderRef = globalRef(
    () =>
        new MetrixUploader({
            auth: webPlaybackAuth,
            device: webPlaybackDeviceProfile,
            endpoints: webPlaybackEndpoints,
            lifecycle: pageLifecycle,
        })
)

export function getMetrixUploader(): MetrixUploader {
    return metrixUploaderRef.value
}
